import { getContainer } from './get-container';

/** Pre-resolved unified container instance for production code. */
export const container = getContainer();
